import React from "react";
import DefaultLayout from "../layouts/DefaultLayout";
import { useWorkplace } from "../context/WorkplaceContext";
import IonIcon from "../components/IonIcon";
import cctvSample from "../images/cctv_sample01.jpg";
import t300 from "../images/gm-t300.png";
import logo from "../images/logo.png";
import weatherIcon from "../images/weather_icon.png";
import CustomIcon from "../components/CustomIcon";
import "../styles/dashboard_container.css";

const DashBoardForGate = () => {
  const { selectedWorkplaceId } = useWorkplace(); // Context 사용

  return (
    <div className="dashboard_container">
      <div className="wrapper">
        <div className="layout_column">
          <div className="logobox row_top">
            <div className="logo_wrapper">
              <img src={logo} alt="logo" />
              <span>스마트안전관리시스템</span>
            </div>
          </div>
          <div className="box w_box">
            <div className="w_wrapper">
              <div className="w_leftbox">
                <div className="w_leftbox_column icon">
                  <img src={weatherIcon} alt="weather" />
                </div>
                <div className="w_leftbox_column">
                  <div className="w_row bigtemp">25°</div>
                  <div className="w_row">한 시간 약한 비</div>
                </div>
              </div>
              <div className="w_rightbox">
                <div className="w_rightbox_column">
                  강수확률
                  <br />
                  자외선지수
                </div>
                <div className="w_rightbox_column bold right">
                  17%
                  <br />
                  45%
                </div>
                <div className="w_rightbox_column">
                  미세먼지
                  <br />
                  초미세먼지
                </div>
                <div className="w_rightbox_column bold right">
                  나쁨
                  <br />
                  좋음
                </div>
              </div>
            </div>
          </div>
          <div className="box">
            <div className="titlebox box_titlebox">
              <div className="title">출입현황</div>
            </div>
            <div className="innerbox row">
              <div className="column img">
                <img src={t300} alt="gate" />
              </div>
              <div className="column">
                <div className="visitbox">
                  <div className="type">
                    <span>발주처</span>
                    <span>시공사</span>
                    <span>협력사</span>
                  </div>
                  <div className="number">
                    <span>11</span>
                    <span>18</span>
                    <span>25</span>
                  </div>
                </div>
              </div>
              <div className="column">
                <div className="visitbox">
                  <div className="type">
                    <span>감리</span>
                    <span>VIP</span>
                    <span>외주</span>
                  </div>
                  <div className="number">
                    <span>1</span>
                    <span>2</span>
                    <span>4</span>
                  </div>
                </div>
              </div>
              <div className="column">
                <div className="visitbox">
                  <div className="type">
                    <div>
                      <IonIcon name="IoStatsChart" color="#299F40" />
                      <span>총방문</span>
                    </div>
                    <div>
                      <IonIcon name="IoPerson" color="#299F40" />
                      <span>잔류중</span>
                    </div>
                  </div>
                  <div className="number total">
                    <span>51명</span>
                    <span>39명</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="titlebox  box_titlebox">
              <div className="title">출입내역</div>
            </div>
            <div className="tablebox">
              <table>
                <colgroup>
                  <col style={{ width: "27%" }} />
                  <col />
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "32%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="alignleft">일시</th>
                    <th>소속</th>
                    <th>이름</th>
                    <th>출입장치</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                  <tr>
                    <td className="alignleft">2024-06-28 10:24:52</td>
                    <td>삼일엔지니어링</td>
                    <td>홍길동</td>
                    <td>입실_얼굴인식기#2</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="layout_column">
          <div className="layout_row row_top">
            <div className="watchbox">
              <div className="date">2024년 06월 27일</div>
              <div className="time">13:35:58</div>
            </div>
          </div>
          <div className="layout_row">
            <div className="absolutetop">
              <div className="box top w_small">
                <div className="titlebox">
                  <div className="btns">
                    <button>가설수직구 1#</button>
                    <button className="on">가설수직구 2#</button>
                    <button>가설수직구 3#</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="box margintop piewrapper">
              <div className="pie">
                <div className="state">
                  <div className="backlight"></div>
                  <div className="title">현장안전지수</div>
                  <div className="stat color1">정상</div>
                </div>
                <div
                  className="donut"
                  style={{
                    "--first": 0.2,
                    "--second": 0.2,
                    "--third": 0.2,
                    "--fourth": 0.2,
                    "--fifth": 0.2,
                  }}
                >
                  <div className="donut__slice donut__slice__first"></div>
                  <div className="donut__slice donut__slice__second"></div>
                  <div className="donut__slice donut__slice__third"></div>
                  <div className="donut__slice donut__slice__fourth"></div>
                  <div className="donut__slice donut__slice__fifth"></div>
                </div>
                <div
                  className="donut blur"
                  style={{
                    "--first": 0.2,
                    "--second": 0.2,
                    "--third": 0.2,
                    "--fourth": 0.2,
                    "--fifth": 0.2,
                  }}
                >
                  <div className="donut__slice donut__slice__first"></div>
                  <div className="donut__slice donut__slice__second"></div>
                  <div className="donut__slice donut__slice__third"></div>
                  <div className="donut__slice donut__slice__fourth"></div>
                  <div className="donut__slice donut__slice__fifth"></div>
                </div>
              </div>
              <div className="legends">
                <div className="legend">
                  <div className="bullet"></div>
                  <div className="text">정상</div>
                </div>
                <div className="legend">
                  <div className="bullet"></div>
                  <div className="text">점검</div>
                </div>
                <div className="legend">
                  <div className="bullet"></div>
                  <div className="text">주의</div>
                </div>
                <div className="legend">
                  <div className="bullet"></div>
                  <div className="text">위험</div>
                </div>
                <div className="legend">
                  <div className="bullet"></div>
                  <div className="text">화재</div>
                </div>
              </div>
            </div>
            <div className="box">
              <div className="titlebox column  box_titlebox">
                <div className="title left">환경센서</div>
                <div className="envboxs">
                  <div className="env">
                    <div className="title">온도</div>
                    <div className="unit">(°C)</div>
                    <div className="amount">15.2</div>
                  </div>
                  <div className="env">
                    <div className="title">습도</div>
                    <div className="unit">(%)</div>
                    <div className="amount">45.2</div>
                  </div>
                  <div className="env">
                    <div className="title">미세먼지</div>
                    <div className="unit">(㎍/m3)</div>
                    <div className="amount">0</div>
                  </div>
                  <div className="env">
                    <div className="title">초미세먼지</div>
                    <div className="unit">(㎍/m3)</div>
                    <div className="amount">0</div>
                  </div>
                  <div className="env">
                    <div className="title">일산화탄소</div>
                    <div className="unit">(ppm)</div>
                    <div className="amount">0</div>
                  </div>
                  <div className="env">
                    <div className="title">산소</div>
                    <div className="unit">(%)</div>
                    <div className="amount">20.73</div>
                  </div>
                  <div className="env">
                    <div className="title">황화수소</div>
                    <div className="unit">(ppm)</div>
                    <div className="amount">0</div>
                  </div>
                  <div className="env">
                    <div className="title">메탄가스</div>
                    <div className="unit">(%)</div>
                    <div className="amount">0</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="layout_row">
            <div className="box">
              <div className="titlebox  box_titlebox">
                <div className="btns">
                  <button className="greybtn">
                    Real-time AI Camera Monitoring
                  </button>
                </div>
                <div className="btns right">
                  <a href="#">
                    <IonIcon name="IoSearch" size="small" />
                  </a>
                </div>
              </div>
              <div className="cctvbox">
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
                <div className="wrapper">
                  <img src={cctvSample} className="cctv" alt="video" />
                  <div className="title">강원지역 수직구#2 상부_회전형</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoardForGate;
